// extracted by mini-css-extract-plugin
module.exports = {"confirmationModal":"ConfimationModal_confirmationModal__EiLN_"};